// extracted by mini-css-extract-plugin
module.exports = {"root":"_e3634a4","prizePool":"_16cea38","divider":"_31b9fe0"};